var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"reset-btn button button_download button_icon-text",class:'actions-panel__button btn-download ' + _vm.className,on:{"click":_vm.downloadFile}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }